@let evaluation = evaluationSg();

@if (evaluation) {
  <div
    class="atn-quiver-deployment-modal-evaluation-step-incomplete__variables"
  >
    @for (variable of evaluation.requires; track $index) {
      <atn-display-variable
        class="atn-quiver-deployment-modal-evaluation-step-incomplete__variable"
        [variable]="variable"
        [value]="
          evaluationFeature.selectors.getVariableValue(variable.id).asSignal()
        "
        (valueChange)="onVariableValueChange(variable, $event)"
      />
    }
  </div>
}
